/* 24/sync — generic page choreography (collection, page, search, 404, journal). */
(function () {
  'use strict';
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  onReady(function () {
    if (window.SyncMotion) {
      window.SyncMotion.initBasic().then(function () { window.__syncBooted = true; }).catch(function () { if (window.__syncRestore) window.__syncRestore(); });
    } else if (window.__syncRestore) {
      window.__syncRestore();
    }
  });
})();
